import { getDataIdsFromContract } from '../../../shared/utils/dataId';

export const wizardHeaderStepProgressDataIds = getDataIdsFromContract({
  base: 'wizard-header-step-progress',
  container: '',
  completed: 'completed',
  active: 'active',
  stepNumber: 'step-number'
});
